import React from 'react'
import { withRouter } from 'react-router-dom';
import withAuthentication from './identity/withAuthentication';

import {Row, Col} from 'react-materialize'

import * as routes from '../config/routes';


class NotFound extends React.Component {


  render() {
    return (
      <div class="full-height valign-wrapper">
      <div className="container ">
      <div className="section">
      <div class="container-fluid full-height">
      <div class="row row-height">
      <div class="col-lg-12 content-right" id="start">
          
               <div className="card-panel ">
                  <br/>
               <h5 className=" secondary-color-1-text question-title center-align"> Uh-oh! 😳</h5>
                
                  <Row><p className="mid-size-h center-align">There's nothing here.<a href={routes.BLANK} > Go back</a></p></Row>
               </div>
          
        </div>
      </div>
      </div>
      </div>
      </div>
      </div>
    );
  }
}

export default withRouter(withAuthentication(NotFound));



// WEBPACK FOOTER //
// ./src/components/404.js